import { render, staticRenderFns } from "./team_honor.vue?vue&type=template&id=0e688f5a&"
import script from "./team_honor.vue?vue&type=script&lang=js&"
export * from "./team_honor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports